import Vue from 'vue'

Vue.mixin({
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    }
  }
})
